/**
 * 押金
 */
import React from 'react';
import PropTypes from 'prop-types';
import KeepAlive from '@/routes/KeepAlive';
import TableContent from './components/TableContent';
import styles from './index.module.scss';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XInput, XSelect, XDatePicker, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import { autoPageNum, autopageSize } from '@/assets/config';
import { connect } from 'react-redux';
import model from '@/reducers/user/rider/model';
import http from '@/assets/api/http';
import { message } from 'antd';

class Rap extends React.Component {

    state = {
        gmtCreateStart: undefined, // 发生时间-开始
        gmtCreateEnd: undefined, // 发生时间-结束
        deliveryId: '', // 订单编号
        status: {}, // 状态
        settleId: '',  // 结算单号
        TransTypeDepositEnum: [],  //  业务状态枚举
        tel: ''
    }

    componentDidMount() {
        this.props.getTransTypeDepositEnum();
        this._searchHandle();
    }

    getTransTypeDepositEnum = ()=>{
        let params = {enumName:'TransTypeDepositEnum'};
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', params, 'POST').then((response) => {
            console.log(response);
        }).catch((e) => {
            message.error(e.message);
        });
    }

    _searchHandle = (useCache) => {
        const { pageNum, pageSize, gmtCreateStart, gmtCreateEnd, deliveryId, status, settleId, tel } = this.state;
        let query = {};
        query = {
            tel: tel,
            accountType: 'DEPOSIT',
            id: settleId,
            bizId: deliveryId ? deliveryId : undefined,
            startDate: gmtCreateStart,
            endDate: gmtCreateEnd,
            bizType: status.code,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getSecurityDepositList(query);
    }

    _resetHandle = () => {
        this.setState({
            gmtCreateStart: undefined, // 发生时间-开始
            gmtCreateEnd: undefined, // 发生时间-结束
            deliveryId: '', // 订单编号
            status: {}, // 状态
            settleId: '',
            tel: ''
        }, () => {
            this._searchHandle(); 
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    render() {
        const { gmtCreateStart, gmtCreateEnd, deliveryId, status, settleId, tel } = this.state;
        const { securityDepositList, transTypeDepositEnum } = this.props;

        return (
                <div className={styles.listContainer}>
                    <div className={styles.header}>
                        <SearchBox>
                            <SearchItem>
                                <XDatePicker
                                    label='变动时间'
                                    value={gmtCreateStart}
                                    bindThis={this}
                                    bindName='gmtCreateStart'
                                    isFormat
                                />
                                <XDatePicker
                                    style={{ marginRight: 20 }}
                                    label=''
                                    value={gmtCreateEnd}
                                    bindThis={this}
                                    bindName='gmtCreateEnd'
                                    isFormat
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInput
                                    label='骑手手机号'
                                    placeholder='输入手机号'
                                    value={tel}
                                    bindThis={this}
                                    bindName='tel'
                                    mode='order'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInput
                                    label='结算单号'
                                    placeholder='输入16位交易单号'
                                    value={settleId}
                                    bindThis={this}
                                    bindName='settleId'
                                    mode='order'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInput
                                    label='业务单号'
                                    placeholder='输入16位业务单号'
                                    value={deliveryId}
                                    bindThis={this}
                                    bindName='deliveryId'
                                    mode='order'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XSelect
                                    label='业务类型'
                                    placeholder='请选择业务类型'
                                    renderData={transTypeDepositEnum}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={status.value}
                                    bindThis={this}
                                    bindName='status'
                                    showSearch={true}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XOKButton
                                    label='查询'
                                    onClick={this._searchHandle}
                                />
                                <XCancelButton
                                    label='重置'
                                    onClick={this._resetHandle}
                                />
                            </SearchItem>
                        </SearchBox>
                    </div>
                    <div className={styles.flexBoxContainer} style={{ paddingBottom: 10 }}>
                        <TableContent renderData={securityDepositList} paginationChange={this._paginationChange} />
                    </div>
                </div>
        );
    }
}

Rap.propTypes = {
    history: PropTypes.object, // router history对象
    match: PropTypes.object, // router match对象
    riderID: PropTypes.string,
    getSecurityDepositList: PropTypes.func,
    securityDepositList: PropTypes.object,
    getTransTypeDepositEnum: PropTypes.func,
    transTypeDepositEnum: PropTypes.array,
};

const mapStateToProps = (state) => ({
    securityDepositList: state.rider.getSecurityDepositList,
    transTypeDepositEnum: state.rider.getTransTypeDepositEnum
});

export default connect(mapStateToProps, { ...model.actions })(Rap);